__turbopack_context__.v({
  "arrows": "style-module-scss-module__O7NsMW__arrows",
  "column": "style-module-scss-module__O7NsMW__column",
  "flex": "style-module-scss-module__O7NsMW__flex",
  "item": "style-module-scss-module__O7NsMW__item",
  "list": "style-module-scss-module__O7NsMW__list",
  "photos": "style-module-scss-module__O7NsMW__photos",
  "slide": "style-module-scss-module__O7NsMW__slide",
  "specialists": "style-module-scss-module__O7NsMW__specialists",
  "swiper": "style-module-scss-module__O7NsMW__swiper",
  "title": "style-module-scss-module__O7NsMW__title",
  "wrapper": "style-module-scss-module__O7NsMW__wrapper",
});
